import styled from 'styled-components'

export const BenefitSelectorContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 4rem;

	div#buttons-container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 1.5rem;

		div.buttons-rows {
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: 0.5rem;
		}
	}
`
